import { Button } from '@iwoca/orion';

import { useGetBuyerSpendingLimitRequest } from '../../../../api/lending/lapiHooks';
import { DeclinedApplicationState } from '../../Dashboard.types';

export const DeclinedApplication = ({
  application,
}: {
  application?: DeclinedApplicationState;
}) => {
  const redirectUrl = application?.payLink.redirect_url || '';

  const { spendingLimitRequest, loadingSpendingLimitRequest } =
    useGetBuyerSpendingLimitRequest();

  const handleClick = () => {
    window.location.href = redirectUrl;
  };

  if (loadingSpendingLimitRequest) return null;

  return (
    <div className="flex flex-col gap-l px-l py-m">
      <h2 className="m-0 text-2xl font-bold">
        Sorry, we can't approve your{' '}
        {spendingLimitRequest?.data?.uuid ? (
          <span>spending limit request</span>
        ) : (
          <span>application</span>
        )}{' '}
        <span>today.</span>
      </h2>
      <p className="m-0 text-m font-reg text-structure-20">
        If you'd like to speak to us about the decision or you have any
        questions, give us a ring on{' '}
        <a
          className="font-bold text-primary-40 underline"
          href="tel:0203 778 0549"
        >
          0203 778 0549
        </a>
      </p>
      {redirectUrl && <Button onClick={handleClick}>Return to merchant</Button>}
    </div>
  );
};
